import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchProviderLocations,
  fetchUpdateProviderLocationStatus,
} from "../../../store/ProviderInfo/ProviderLocationActions";
import "./ProviderLocation.scss";
import ToggleButton from "../../../common/ToggleButton";
import PopupModal from "../../../common/PopupModal";
import CgFormCreator from "../../../common/CgFormCreator";
import GoogleMapComponent from "../../../common/GoogleMapComponent";
import { useLocation,Link } from "react-router-dom";
import { isActiveForPracticeAndProviderAndAccessPoint } from "../../../utils/commonUtilities";

const ProviderLocation = () => {
  const [filterData, setFilterData] = useState("ALL");
  const [filteredLocationList, setFilteredLocationList] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);
  const [editItem, setEditItem] = useState({});
  const [resetCount, setResetCount] = useState(false);
  const [statusDropdown, setStatusDropdown] = useState("");
  const [latLngList, setLatLngList] = useState([]);
  const [showError, setShowError] = useState(false);
  const [reason, setReason] = useState("");
  const [note, setNote] = useState("");

  const location = useLocation();
  const locationHeaderData = location.pathname.split("/");
  const providerId = locationHeaderData[2];

  const dispatch = useDispatch();
  const { locationData, locationError, locationErrorMsg } = useSelector(
    (state) => state.providerLocationData
  );

  useEffect(() => {
    const latLngList = [];
    locationData?.map((locationItem) => {
      const data = {
        lat: Number(locationItem.streetAddress.latitude),
        lng: Number(locationItem.streetAddress.longitude),
      };
      latLngList.push(data);
    });
    setLatLngList(latLngList);
  }, [locationData]);

  useEffect(() => {
    if (locationError) {
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
      }, 2000);
    }
  }, [locationError]);

  useEffect(() => {
    dispatch(fetchProviderLocations(providerId));
  }, []);

  useEffect(() => {
    if (filterData === "ALL") {
      setFilteredLocationList(locationData);
    } else if (filterData === "ON") {
      const updatedList = locationData.filter(
        (loc) => loc.status.isActive === true || loc.status.isActive === "true"
      );
      setFilteredLocationList(updatedList);
    } else if (filterData === "OFF") {
      const updatedList = locationData.filter(
        (loc) =>
          loc.status.isActive === false || loc.status.isActive === "false"
      );
      setFilteredLocationList(updatedList);
    }
  }, [filterData, locationData]);

  const onStatusDropDown = [
    {
      name: "Network Status Dispute",
      value: "Network Status Dispute",
    },
    {
      name: "Not Accepting New Patients",
      value: "Not Accepting New Patients",
    },
    {
      name: "Not at Location / Not Practicing",
      value: "Not at Location / Not Practicing",
    },
    {
      name: "I do not recognize this provider",
      value: "I do not recognize this provider",
    },
    {
      name: "Retired/Deceased",
      value: "Retired/Deceased",
    },
  ];

  const offStatusDropdown = [
    {
      name: "Verified",
      value: "Verified",
    },
  ];

  const formStatusSchema = [
    {
      component: "dropdown",
      name: "status",
      dropdownOptions: [
        {
          name: "ON",
          value: "ON",
        },
        {
          name: "OFF",
          value: "OFF",
        },
      ],
      required: true,
      onSelectCallBack: (name, value) => {
        setStatusDropdown(value);
        setReason("");
      },
      defaultValue: !editItem.status?.isActive ? "ON" : "OFF",
    },
    {
      component: "dropdown",
      name: "reason",
      required: true,
      dropdownOptions:
        statusDropdown === "ON" ? offStatusDropdown : onStatusDropDown,
      dropdownPlaceHolder: "Select a Reason",
      onSelectCallBack: (name, value) => {
        setReason(value);
      },
      renderCustomError: Boolean(!reason),
    },
    {
      component: "textarea",
      name: "note",
      label: "Note:",
      cols: 83,
      rows: 10,
      needBorder: true,
      onKeyChangeCallback: (res) => {
        setNote(res);
      },
      renderCustomError: Boolean(!note),
    },
  ];

  const RenderLocationStatus = () => {
    return (
      <div>
        <div className="statusHeader"> YOUR STATUS </div>
        <div className="locationPopupDescWrapper">
          <p className="disclaimer">
            These Changes will be reflected in Brighter's records.
          </p>
          <p className="disclaimer">
            Please notify contracted carries of any changes to providers at your
            practice.
          </p>
        </div>
        <div className="statusWrapper">
          <CgFormCreator
            key={resetCount}
            schema={formStatusSchema}
            enablePrimaryBtn={Boolean(reason) && Boolean(note)}
            onSubmitCallback={(val) => {
              const payload = {
                reasonCode: val.reason,
                note: val.note,
                isActive: val.status === "ON" ? "true" : "false",
              };
              dispatch(
                fetchUpdateProviderLocationStatus({
                  providerId: providerId,
                  locationId: editItem.practiceDisplayId,
                  data: payload,
                })
              ).then(() => {
                dispatch(fetchProviderLocations(providerId));
              });
              setOpenPopup(!openPopup);
              setReason("");
              setNote("");
            }}
            onCancel={() => {
              setResetCount(!resetCount);
              setEditItem({});
              setOpenPopup(!openPopup);
              setReason("");
              setNote("");
            }}
          />
        </div>
      </div>
    );
  };

  const RenderPopup = () => {
    return (
      <div className="practice-status-popup">
        <PopupModal
          isOpen={openPopup}
          onClose={() => {
            setOpenPopup(!openPopup);
            setResetCount(!resetCount);
            setReason("");
            setNote("");
          }}
          width="50%"
          customRender={RenderLocationStatus}
        />
      </div>
    );
  };

  const RenderLocationList = () => {
    return (
      <div>
        {filteredLocationList?.map((locationItem) => {
          return (
            <>
              <div className="locationCardWrapper">
                <div className="locationCardHeaderWrapper">
                  <Link
                    className="locationName"
                    to = {`/practice/${locationItem?.practiceDisplayId}/profile-information/info`}
                  >
                    {locationItem.practiceName}
                  </Link>
                  <div
                    data-testid={`${
                      locationItem.status?.isActive ? "toggleOn" : "toggleOff"
                    }`}
                  >
                    {/**
                     *  Provider -> Locations -> Practice status on card
                     */}
                    <ToggleButton
                      key={resetCount}
                      customToggleStyle
                      defaultValue={
                        isActiveForPracticeAndProviderAndAccessPoint(locationItem.status)? true : false
                      }
                      isReasonRequired = {false}
                      onChangeCallback={() => {
                        const status = locationItem.status?.isActive
                          ? "OFF"
                          : "ON";
                        setStatusDropdown(status);
                        setEditItem(locationItem);
                        setOpenPopup(!openPopup);
                        setReason("");
                        setNote("");
                      }}
                    />
                  </div>
                </div>
                <div className="locationCardBodyWrapper">
                  <div className="locationCardBodyItem">
                    PRACTICE ID -{" "}
                    <span className="boldLtr">
                      {locationItem.practiceDisplayId}
                    </span>
                  </div>
                  <div className="locationCardBodyItem">
                    ADDRESS -{" "}
                    <span className="boldLtr">
                      {locationItem.streetAddress.street1},
                      {locationItem.streetAddress.city},
                      {locationItem.streetAddress.state},
                      {locationItem.streetAddress.postalCode}
                    </span>
                  </div>
                </div>
              </div>
            </>
          );
        })}
      </div>
    );
  };

  return (
    <div className="practiceLocationWrapper">
      <div className="locationMapWrapper">
        <GoogleMapComponent
          latLngList={latLngList}
          zoomLevel={13}
          needIcon={true}
        />
      </div>
      <div className="practiceLocationListWrapper">
        <div className="practiceLocationHeader">
          <div className="PracticeLocationHeader">Practice Locations </div>
          <div className="practiceLocationFilters">
            <div
              className={`${
                filterData === "ALL" ? "filterBtn" : "noFilterBtn"
              }`}
              onClick={() => {
                setFilterData("ALL");
              }}
            >
              ALL
            </div>
            <span className="filter-separator">|</span>
            <div
              className={`${filterData === "ON" ? "filterBtn" : "noFilterBtn"}`}
              onClick={() => {
                setFilterData("ON");
              }}
              data-testid="filterBtnOn"
            >
              ON
            </div>
            <span className="filter-separator">|</span>
            <div
              className={`${
                filterData === "OFF" ? "filterBtn" : "noFilterBtn"
              }`}
              onClick={() => {
                setFilterData("OFF");
              }}
              data-testid="filterBtnOff"
            >
              OFF
            </div>
          </div>
        </div>
        {showError && (
          <div className="alert alert-danger" role="alert">
            {locationErrorMsg}
          </div>
        )}
        {RenderLocationList()}
        {RenderPopup()}
      </div>
    </div>
  );
};

export default ProviderLocation;
